export default "__VITE_ASSET__ed76b75c__"